var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.auditLog
    ? _c(
        "jll-modal",
        {
          staticClass: "modal-position-fixed",
          attrs: {
            value: !!_vm.auditLog,
            header: _vm.$t("common.modalAudit.lblTitle"),
            "show-footer": "",
          },
          on: {
            input: function ($event) {
              return _vm.$store.dispatch("auditLogModule/closeModal")
            },
          },
        },
        [
          !_vm.auditLog || !_vm.auditLog.length
            ? _c("p", [
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("common.modalAudit.msgNoChanges"))),
                ]),
              ])
            : _vm._l(_vm.mutatedAuditLogData, function (entry, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "panel panel-primary modal-audit-log",
                  },
                  [
                    _c("div", { staticClass: "panel-body" }, [
                      _c(
                        "div",
                        { staticClass: "mb-3 pl-1" },
                        [
                          _c("comps-audit-log-modal-table-title", {
                            attrs: { data: entry },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-condensed table-striped table-bordered table-hover small",
                            attrs: { border: "1" },
                          },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "bg-primary" }, [
                                _c(
                                  "th",
                                  { staticClass: "bg-dark text-light" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.modalAudit.table.colField"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  { staticClass: "bg-dark text-light" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.modalAudit.table.colBefore"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  { staticClass: "bg-dark text-light" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.modalAudit.table.colAfter"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                entry.FieldsAudit,
                                function (field, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(_vm._s(field.Field)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(field.Before))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(field.After))]),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }